<ion-item *ngIf="item.name !== (serviceChargeName || 'Kyoo Service Charge') && item.name !== 'Spot in line'" class="cart-item" [lines]="lines" [class.cart-item--brand-color]="brandColor" [class.cart-item--transparent]="transparent" [class.cart-item--border-top]="isBorderTop">

  <div class="shared-order-name" *ngIf="item?.metadata">
    {{item?.metadata?.customer_name}}
  </div>
  <ion-label class="cart-item__title">{{item.name}}
    <span  *ngIf="item?.variation && item?.variation?.name?.length">({{item.variation.name}})</span>
    <span class="cart-item__quantity">&nbsp;x {{item.quantity}}</span>
    <p *ngIf="item.modifiers?.length && !isAllModifiersHidden(item.modifiers)">
      <ion-text class="cart-item__subtitle">Modifiers:&nbsp;</ion-text>
      <ion-text class="cart-item__details">
        <ion-text *ngFor="let modifier of item.modifiers; let last = last"
                      [hidden]="formatDataService.containsKeyword(modifier.name, 'HIDDEN') || modifier.hiddenFromCustomer">
          <ion-text class="cart-item__details-name">{{cleanedName(modifier.name)}}{{modifierPrice(modifier)}}</ion-text>
          <ng-container *ngIf="!last">,&nbsp;</ng-container>
        </ion-text>
      </ion-text>
    </p>
  </ion-label>
  <div class="cart-item__right-info ion-float-right">
    <ion-label *ngIf="hasPrice" class="cart-item__price">
      ${{getFormattedPrice((item.totalItemPrice.amount / 100) + (displayKyooFee && item.totalItemPrice.amount > 100 ? (cartStore.kyooFee/item.quantity)/100 : 0), item.quantity)}}
    </ion-label>
    <div>
      <ion-button *ngIf="hasEdit && !sharedOrderService.sharedOwnerId$" class="cart-item__button" (click)="editItemFromCart()" size="small" fill="clear"
                  color="brand" [disabled]="buttonsDisabled">Edit
      </ion-button>
      <ion-button *ngIf="hasDelete"
                  [hidden]="item.isService"
                  class="cart-item__button"
                  (click)="deleteItemFromCart()" size="small" fill="clear"
                  color="brand" [disabled]="buttonsDisabled">Remove
      </ion-button>
    </div>
    <span class="cart-item__invalid-message" *ngIf="showTimeBasedErrorMessage && !isValidLeadTime">This item requires more lead time.</span>
    <span class="cart-item__invalid-message" *ngIf="!isValidDay || !isValidFulfillment">{{availableText}}</span>
    <span class="cart-item__invalid-message" *ngIf="showTimeBasedErrorMessage && !isValidDatetimeRange">{{datetimeRangeText}}</span>
    <span class="cart-item__invalid-message" *ngIf="showTimeBasedErrorMessage && !isValidDay">Please select a different pickup date.</span>
    <span class="cart-item__invalid-message" *ngIf="showTimeBasedErrorMessage && !isValidRestaurantFulfillment">This item is not available for the selected fulfillment.</span>
    <span class="cart-item__invalid-message" *ngIf="!isValidRestaurantTime">This item is not available at this time. Please select a different pickup date.</span>
    <span class="cart-item__invalid-message" *ngIf="isShowFutureOrderError">This item is sold out today. Please select a different pickup date.</span>
    <span class="cart-item__invalid-message throttling-message" *ngIf="hasEdit && item.throttlingEstimation">
      <span class="material-icons icon-color">warning</span>
      Estimated wait time: &nbsp;<strong>{{item.throttlingEstimation}}</strong>
    </span>
  </div>
</ion-item>
